import React from "react";
import { AppBar, Toolbar, Box, Button } from "@mui/material";

const Navbar = ({ onGetStartedClick }) => {
  return (
    <AppBar
      position="static"
      elevation={1}
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        padding:"10px",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Logo */}
        <Box
            component="img"
            src="/arNXTnew.png"     
            alt="arNXT"
            sx={{ height: { xs: 50, md: 65 }, width: { xs: 100, md: 130 } }}
          />

        {/* Get Started Button */}
      <Button
  variant="contained"
  onClick={onGetStartedClick}
  sx={{
    backgroundColor: "#012A38",
      fontWeight: 600,
    mr:"20px",
    fontSize: "16px", 
    height: "50px",
    borderRadius: "5px", 
    textTransform: "none",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#0e3846ff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    },
  }}
>
  Get Started
</Button>

      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
